export default "__VITE_ASSET__0c4023fe__"